import { useApolloClient } from '@apollo/client';

import { MUTATION as ADD_WEB_PHOTO } from '../graphql/mutations/web/maintenance/useAddWebPhoto';
import { QUERY as GET_PRESIGNED_UPLOAD_URL } from '../graphql/queries/web/maintenance/useGetPresignedUploadUrl';

const uploadImage = async (uploadUrl: string, file: any) => {
  if (!uploadUrl || !file) {
    return Promise.resolve();
  }

  return fetch(uploadUrl, {
    method: 'PUT',
    body: file,
  });
};

interface UseUploadPhotosArgs {
  maintenanceRequestId: string;
}

export const useUploadPhotos = ({ maintenanceRequestId }: UseUploadPhotosArgs) => {
  const client = useApolloClient();

  return [
    async (files: any, kind: string) => {
      await Promise.all(
        files.map(async (file: any) => {
          const { data } = await client.query({
            query: GET_PRESIGNED_UPLOAD_URL,
            variables: {
              maintenanceRequestId: maintenanceRequestId,
              fileName: file.name,
            },
          });

          if (data) {
            const uploadUrl = data?.webMaintenance.getPresignedUploadUrl?.presignedUploadUrl;
            const key = data?.webMaintenance.getPresignedUploadUrl?.key;

            await uploadImage(uploadUrl, file);

            await client.mutate({
              mutation: ADD_WEB_PHOTO,
              variables: {
                key: key,
                kind: kind,
                picableId: maintenanceRequestId,
                picableType: 'MaintenanceRequest',
              },
            });
          }
        }),
      );
    },
  ];
};
